import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { SignedIn, SignedOut, RedirectToSignIn } from "@clerk/clerk-react";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import SegmentsPage from "./pages/SegmentsPage";
import SegmentFormPage from "./pages/SegmentFormPage";
import LinkedInSuccessPage from "./pages/LinkedInSuccessPage";
import GuidePage from "./pages/GuidePage";
import PricingPage from "./pages/PricingPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import ClerkTokenBridge from "./components/ClerkTokenBridge";

function ProtectedRoute({ children }) {
  return (
    <>
      <SignedIn>
        <Layout>{children}</Layout>
      </SignedIn>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
    </>
  );
}

export default function App() {
  return (
    <>
      {/* Keep Clerk Bearer tokens available on public routes too (e.g. /pricing) */}
      <SignedIn>
        <ClerkTokenBridge />
      </SignedIn>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route
          path="/pricing"
          element={
            <>
              <SignedIn>
                <Layout>
                  <PricingPage embedded />
                </Layout>
              </SignedIn>
              <SignedOut>
                <PricingPage />
              </SignedOut>
            </>
          }
        />
        <Route path="/cgu" element={<TermsPage />} />
        <Route path="/confidentialite" element={<PrivacyPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/segments"
          element={
            <ProtectedRoute>
              <SegmentsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/segments/new"
          element={
            <ProtectedRoute>
              <SegmentFormPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/segments/:id/edit"
          element={
            <ProtectedRoute>
              <SegmentFormPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/guide"
          element={
            <ProtectedRoute>
              <GuidePage />
            </ProtectedRoute>
          }
        />
        <Route path="/linkedin/success" element={<LinkedInSuccessPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
